module.exports = __webpack_public_path__ + "img/confirmfebvideoflow-price.26799d31.png";